import { Flex, Typography } from "antd"
import cls from "classnames"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { useLocation, useNavigate } from "react-router"

import ButtonComponent from "../../../../../Components/Button"
import InfoTooltip from "../../../../../Components/InfoTooltip/InfoTooltip"
import Images from "../../../../../Images"
import BrandTag from "../../../components/BrandTag/BrandTag"
import { ESTIMATED_STATUS_TOOLTIP } from "../../../components/Monitoring/monitoringCopy"
import PeriodLabel from "../../../components/Monitoring/PeriodLabel/PeriodLabel"
import PermissionPlaceholder from "../../../components/PermissionPlaceholder"
import useHealthAccessRestricted from "../../../hooks/useHealthAccessRestricted"
import { useIsStripeConnected } from "../../hooks/useIsStripeConnected"
import ConnectStripePlaceholder from "../ConnectStripePlaceholder/ConnectStripePlaceholder"
import MastercardEstimatedProgramStatusTable from "./Table/MastercardEstimatedProgramStatusTable"

import "./MastercardEstimatedProgramStatus.less"

const { Text } = Typography

const MastercardEstimatedProgramStatus = ({ business_account_id }) => {
  const navigate = useNavigate()
  const { search } = useLocation()
  const { t } = useTranslation()
  const isRestricted = useHealthAccessRestricted()
  const { isMobile } = useSelector((state) => state.nav)
  const isStripeConnected = useIsStripeConnected()

  const handleViewAll = () => {
    navigate(`mastercard_estimated_program_status${search}`)
  }

  return (
    <div className="mc-estimated-program-status-wrap">
      <div className="mc-estimated-program-status">
        <Flex className="header" align="flex-start" justify="space-between" gap={10}>
          <Flex align="center" gap={8}>
            <Text>Estimated program status</Text>
            <BrandTag label="Mastercard" image={Images.mastercard_3d} />
            <InfoTooltip title={ESTIMATED_STATUS_TOOLTIP} />
          </Flex>
          {!isRestricted && (
            <Flex align="center" gap={12}>
              <PeriodLabel />
              {!isMobile && (
                <ButtonComponent onClick={handleViewAll}>{t("View All")}</ButtonComponent>
              )}
            </Flex>
          )}
        </Flex>

        {isRestricted ? (
          <PermissionPlaceholder minHeight={300} />
        ) : (
          <div
            className={cls("mc-stripe-gated-content", {
              "is-stripe-disconnected": !isStripeConnected
            })}
            style={!isStripeConnected ? { minHeight: 300 } : undefined}
          >
            <MastercardEstimatedProgramStatusTable
              business_account_id={business_account_id}
              variant="block"
              pageSize={5}
            />
            {!isStripeConnected && <ConnectStripePlaceholder />}
          </div>
        )}
      </div>

      {!isRestricted && isMobile && (
        <ButtonComponent
          style={{ width: "100%", marginTop: 16, height: 40 }}
          onClick={handleViewAll}
        >
          {t("View All")}
        </ButtonComponent>
      )}
    </div>
  )
}

export default MastercardEstimatedProgramStatus
